module.exports = __webpack_public_path__ + "img/soft-grove-bathroom-1.9d97c435.jpeg";